import React from "react";
import {Bold, InlineLink, ListItem, Paragraph, SectionHeading, usePromotionsText} from "../PromotionsText";

const IntroductionSection = () => {
  const {navigation} = usePromotionsText();

  return (
    <>
      <Paragraph>{"Last Updated: June 19, 2026"}</Paragraph>

      <SectionHeading>Introduction</SectionHeading>

      <ListItem marker="(a)">
        {"New Evenplay (“"}<Bold>{"Us"}</Bold>{"” or \""}<Bold>{"Our"}</Bold>{"” or “"}<Bold>{"We"}</Bold>{"”) users (“"}<Bold>{"User"}</Bold>{"” or “"}<Bold>{"You"}</Bold>{"” or “"}<Bold>{"Your"}</Bold>{"”) may qualify for certain promotions (“"}<Bold>{"Promotions"}</Bold>{"”) offered by Evenplay from time to time. Promotions offered through any of Evenplay’s Platforms are subject to Evenplay’ Terms of Use "}
        <InlineLink onPress={() => navigation.navigate('TermsAndConditions')}>
          {"www.evenplay.com/termsandconditions"}
        </InlineLink>
        {" (“General Terms”), these Promotions Terms and Conditions (“Promotion Terms”), together with any applicable Key Terms (which may also be referred to as “Key Terms”), set out on the individual web landing page for the relevant Promotion(s), and Evenplay’ Privacy Policy (“Privacy Policy”) "}
        <InlineLink onPress={() => navigation.navigate('PrivacyPolicy')}>{"app.evenplay.com/privacy"}</InlineLink>
        {" (collectively, the “Rules”)."}
      </ListItem>

      <ListItem marker="(b)" withBottomMargin>
        {"The Rules form a legal agreement between You and Us and can only be amended with Our consent. By participating in any Promotion, You are indicating You accept and agree to be bound by the Rules. Capitalized terms used but not defined in these Promotion Terms have the meanings ascribed to them in the General Terms. In the event of any conflict or inconsistency between these Promotion Terms, any applicable Key Terms, and the General Terms, the Key Terms shall prevail, followed by these Promotion Terms, but only to the extent necessary to resolve such conflict or inconsistency. Your use of each Platform itself and of any services available through that Platform are subject to the Rules."}
      </ListItem>
    </>
  );
};

export default IntroductionSection;
